"use client";

import { useDemoButtonText } from "@/hooks/useDemoButtonText";

type DemoButtonTextProps = {
  fallback: string;
};

export default function DemoButtonText({
  fallback,
}: Readonly<DemoButtonTextProps>) {
  const flagText = useDemoButtonText();
  return <>{flagText ?? fallback}</>;
}
